export default "__VITE_ASSET__31d2e151__"